import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';

import { DATABASE_CONFIG, getMethodColorClass, buildFullPath } from '../database.config';

/**
 * @class ModelEndpointsTableComponent
 * @description A dumb component responsible for rendering a Swagger-style API Endpoints table. 
 * Uses pure functions to map methods to semantic colors and paths to RESTful URL structures.
 */
@Component({
  selector: 'rapider-model-endpoints-table',
  standalone: true,
  imports: [CommonModule, NzTableModule, NzTagModule],
  templateUrl: './model-endpoints-table.component.html',
})
export class ModelEndpointsTableComponent {
  /** Array of endpoint objects retrieved from the project model metadata. */
  @Input() endpoints: any[] = [];

  /** The base name of the model, used to construct RESTful paths (e.g. 'UiMenuItem'). */
  @Input() baseModelName: string = '';

  public readonly config = DATABASE_CONFIG;

  /** Resolves the semantic tailwind classes for the HTTP method. */
  public getMethodColor(method: string): string {
    return getMethodColorClass(method);
  }

  /** Resolves the full URL path string by combining the base model name and endpoint path. */
  public getFullPath(path: string): string {
    return buildFullPath(this.baseModelName, path);
  }
}